import { i18n } from '@/i18n'

export default {
  methods: {
    unauthorized() {
      this.$message({ type: 'error', message: i18n.tc('unauthorized') })
    },
  },
}
